import './coordinations.module';
import './coordinations.config';
import './$coordinations.factory';

import './components';
import './constants';
import './services';
